export default {
  font: {
    fontFamily: "'Poppins', sans-serif",
  },
  colors: {
    primary: "blue",
    secondary: "aliceblue",
    inverse: "white",
    borderColor: "#eee"
  },
  padding: "1rem",
  fact: {
    layout: {
      display: "flex",
      padding: "0 1rem",
      marginBottom: "2rem",
      paddingBottom: "2rem",
      borderBottom: "1px solid #eee",
      flexWrap: "wrap"
    },
    left: {
      width: "5.5rem",
      margin: "0 1rem",
      justifyContent: "center",
      flex: "1",
      display: "flex",
      alignItems: "flex-start"
    },
    right: {
      width: "400px",
      maxWidth: "100%"
    },
    source: {
      fontSize: "0.875rem",
      color: "#666",
      padding: "1rem 0"
    },
    heading: {
      //marginTop: "0"
    }

  },
  form: {
    input: {
      padding: ".75rem 1rem",
      border: "1px solid #ddd",
      borderRadius: "4px",
      margin: ".5rem 0 2rem 0",
      fontSize: "1rem"
    },
    label: {
      fontWeight: 700,
      color: "#000"
    }
  },
  footer: {
    layout: {
      margin: "4rem 0",
      textAlign: "center",
      fontSize: "0.875rem"
    },
    link: {
      color: "#333",
      textDecoration: "none",
      padding: "0 1rem 1rem",
      display: "inline-block"
    }
    
  },
  lightButton: {
    fontFamily: "Poppins",
    background: "rgba(255,255,255,0.5)",
    color: "#fff",
    borderRadius: "32px",
    fontSize: "14px",
    padding: "5px 12px",
    fontWeight: 600,
    border: "none",
    marginTop: "0.5rem",
    cursor: "pointer"
  }


}


// WEBPACK FOOTER //
// ./src/style/style.js